import { LEDModes } from "@aura-frontend/omnibus-az-client";
import { Card, Label, RadioGroup, RadioGroupItem } from "@win-reality/react-ui";

import { subsystemHealth } from "@/utils/machineHealth";

import PulseIcon from "../../../assets/pulse.svg";
import { HealthyIndicator } from "../../../pages/Complexes/SingleComplex/FieldCard";
import { LedModesLabels, STANDBY_LABEL } from "./ledModes";

// `<RadioGroup value>` must be a string; use this sentinel for the Standby
// option, which corresponds to a `null` ledBoardMode (no LED endpoint fires on
// live start, `internal.led: null` on schedule).
const STANDBY = "standby";

type EventLEDBoardConfigurationProps = {
  isFieldHealthy: boolean;
  value?: LEDModes | null;
  onValueChange?: (value: LEDModes | null) => void;
};

function EventLEDBoardConfiguration({
  isFieldHealthy,
  value,
  onValueChange,
}: EventLEDBoardConfigurationProps) {
  return (
    <div>
      <div className="text-base font-bold w-full">LED Board Configuration</div>

      <Card className="mt-5">
        <div className="flex flex-col gap-8">
          <div className="flex gap-4 items-center @container">
            <img src={PulseIcon} alt="P" className="h-7 w-auto" />

            <div>
              <div className="text-sm">SmartPark Health</div>

              <div className="flex flex-col gap-1 mt-1 @[400px]:flex-row @[400px]:gap-4">
                <div className="flex text-xs">
                  Stat Tracking
                  <HealthyIndicator health={subsystemHealth(isFieldHealthy)} />
                </div>

                <div className="flex text-xs">
                  Umpire Assist
                  <HealthyIndicator health={subsystemHealth(isFieldHealthy)} />
                </div>
              </div>
            </div>
          </div>

          <RadioGroup
            value={value ?? STANDBY}
            onValueChange={(v) =>
              onValueChange?.(v === STANDBY ? null : (v as LEDModes))
            }
            className="gap-4 justify-start"
          >
            <Label
              variant="control"
              htmlFor="r1"
              className="rounded-full flex w-fit bg-accent-dark-2/50 cursor-pointer items-center gap-2  px-3 py-2"
            >
              <RadioGroupItem
                value={STANDBY}
                id="r1"
                className="border-accent-light-1/30"
              />
              <span className="text-sm">{STANDBY_LABEL}</span>
            </Label>

            <Label
              variant="control"
              htmlFor="r2"
              className="rounded-full flex w-fit bg-accent-dark-2/50 cursor-pointer items-center gap-2  px-3 py-2"
            >
              <RadioGroupItem
                value="stat_tracking"
                id="r2"
                className="border-accent-light-1/30"
              />
              <span className="text-sm">{LedModesLabels.stat_tracking}</span>
            </Label>

            <Label
              variant="control"
              htmlFor="r3"
              className="rounded-full flex w-fit bg-accent-dark-2/50 cursor-pointer items-center gap-2  px-3 py-2"
            >
              <RadioGroupItem
                value="umpire_assist"
                id="r3"
                className="border-accent-light-1/30"
              />
              <span className="text-sm">{LedModesLabels.umpire_assist}</span>
            </Label>

            <Label
              variant="control"
              htmlFor="r4"
              className="rounded-full flex w-fit bg-accent-dark-2/50 cursor-pointer items-center gap-2  px-3 py-2"
            >
              <RadioGroupItem
                value="blocked"
                id="r4"
                className="border-accent-light-1/30"
              />
              <span className="text-sm">{LedModesLabels.blocked}</span>
            </Label>
          </RadioGroup>
        </div>
      </Card>
    </div>
  );
}

export { EventLEDBoardConfiguration };
